// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	TitleSearchCompletionDatePicker: 'title-search-completion-date-picker',
} as const;
